"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Button, useMediaQuery } from "@mui/material";
import routes from "@/app.route";

export default function HeroBanners() {
  const matches = useMediaQuery("(min-width:1024px)");
  const banners = [
    {
      title: "Sony Alpha 7V",
      slug: "sony-alpha-a7-v-mirrorless-camera",
      subtitle: "Full-frame hybrid camera",
      desktopImage: "/images/home/alpha-7V.webp",
      mobileImage: "/images/home/alpha-7V-mobile.webp",
    },
    // {
    //   title: "Compact Powerhouse for Aerial Creators",
    //   slug: "dji-mini-5-pro",
    //   icon: "/images/home/Mini-5-pro-icon.svg",
    //   subtitle: "Mini to the Max",
    //   desktopImage: "/images/home/Mini-5-pro.webp",
    //   mobileImage: "/images/home/Mini-5-pro-mobile.webp",
    // },
    // {
    //   title: "Follow Me Camera Drone",
    //   slug: "dji-neo-2-fly-more-combo-drone",
    //   icon: "/images/home/Neo-2-icon.svg",
    //   subtitle: "Fly Your Way",
    //   desktopImage: "/images/home/Neo-2.webp",
    //   mobileImage: "/images/home/Neo-2-mobile.webp",
    // },
  ];

  return (
    <section style={{ background: "#252525" }}>
      <Swiper
        modules={[Autoplay, Navigation]}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        slidesPerView={1}
        loop
        navigation={matches}
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundImage: `url("${matches ? banner.desktopImage : banner.mobileImage}")`,
                height: "calc(100vh - 210px)",
              }}
            >
              <div className="max-w-sm mx-auto py-8 md:py-12">
                <div className="text-center font-medium text-white opacity-70 mb-3 text-base">
                  {banner.title}
                </div>
                <div className="text-center font-semibold text-lg text-white mb-6">
                  {banner.subtitle}
                </div>
                {banner.slug && (
                  <div className="flex gap-4 justify-center">
                    <Button
                      size="large"
                      variant="contained"
                      href={routes.product.url.replace(":slug", banner.slug)}
                    >
                      Buy Now
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
